import { formatDate } from "../../../helpers/date";

export const INVOICE_DETAIL_COLUMNS = [
  {
    Header: "Customer No",
    id: "customerNumber",
    accessor: "customerNumber",
    maxWidth: 180
  },
  {
    Header: "Posting Date",
    id: "postingDate",
    accessor: "postingDate",
    Cell: ({ value }) => formatDate(new Date(value), "MM/dd/yy"),
    maxWidth: 120
  },
  {
    Header: "Type",
    id: "type",
    accessor: "type",
    maxWidth: 100
  },
  {
    Header: "Item No.",
    id: "itemNo",
    accessor: "itemNo",
    maxWidth: 200
  },
  {
    Header: "Description",
    id: "description",
    accessor: "description"
  },
  {
    Header: "Variant",
    id: "variant",
    accessor: "variant",
    maxWidth: 100
  },
  {
    Header: "Qty",
    id: "qty",
    accessor: "qty",
    maxWidth: 100
  },
  {
    Header: "Unit Price",
    id: "unitPrice",
    accessor: "unitPrice",
    Cell: ({ value }) => (value ? `$${value}` : ""),
    maxWidth: 100
  },
  {
    Header: "Cost Center Code",
    id: "costCenterCode",
    accessor: "costCenterCode"
  },
  {
    Header: "Tax Code",
    id: "taxCode",
    accessor: "taxCode"
  }
];
